import React from 'react';
import { Loader2 } from 'lucide-react';
import { useEdificioOp } from '../../contexts/EdificioOpContext';
import OperacionesEdificioDetalle from './OperacionesEdificioDetalle';

/**
 * Renderiza la pantalla de configuración del edificio actualmente activo
 * (Unidades & Usuarios / Salas / Límites / Configuración).
 * Se diferencia de OperacionesEdificioDetalle (que toma el id de la URL) en que
 * acá el id viene del context global del operador.
 */
export default function OperacionesConfigurar() {
  const { edificioId, loading } = useEdificioOp();
  if (loading) return <div className="p-12 text-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400 inline" /></div>;
  if (!edificioId) return <div className="p-8 text-center text-slate-500">Elegí un edificio en el menú lateral.</div>;
  return <OperacionesEdificioDetalle key={edificioId} edificioId={edificioId} hideBack />;
}
